import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ArrowForwardIosOutlined, AccessTime } from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Backdrop,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { yellow } from "@mui/material/colors";
import { status, labelStatusVinculo } from "../utils/labels";

import AdicionarVinculos from "../pages/Vinculos/adicionarVinculo";

import { ReactComponent as IconStarFill } from "../images/iconStarFill.svg";
import { ReactComponent as IconStar } from "../images/iconStar.svg";
import { ReactComponent as IconEdit } from "../images/iconEdit.svg";
import { ReactComponent as IconRemoveUser } from "../images/iconRemoveUser.svg";
import { ReactComponent as IconLocation } from "../images/iconLocation.svg";
import { ReactComponent as IconHospital } from "../images/iconHospital.svg";

import api from "../services/api";
import ModalDialogs from "./ModalDialogs";
import { setItemEncryp } from "../utils/cryptoData";

const styles = {
  profile: {
    fontSize: "1.4rem",
    fontWeight: "500",
    color: "#063F5E",
  },
  label: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#063F5E",
  },
  content: {
    width: "220px",
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    height: "22px",
    alignItems: "center",
    fontFamily: "inherit",
  },
  contentEstabelecimento: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    alignItems: "start",
  },
  border: {
    border: "1px solid #CCCCCC",
    borderRadius: "5px",
    width: "100%",
    height: "100%",
    padding: "16px",
    gap: "8px",
    boxSizing: "border-box",
  },
  boxIcons: {
    height: "22px",
    alignItems: "center",
    display: "flex",
  },
};

export default function VinculoCard({
  statusVinculo = "",
  favorito = false,
  perfil = "",
  municipio = "",
  estabelecimentoDeSaude = "",
  vinculoId,
  setRefresh,
  refresh,
}) {
  const navigate = useNavigate();
  const [modalDelete, setModalDelete] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmReativar, setConfirmReativar] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openModalReativar, setOpenModalReativar] = useState(false);
  const [openModalEditar, setOpenModalEditar] = useState(false);
  const [dados, setDados] = useState([]);
  const [vinculoFavorito, setVinculoFavorito] = useState(favorito);
  const handleRefresh = (value) => setRefresh(value);

  const handleCloseEditar = () => setOpenModalEditar(false);
  const handleCloseReativar = () => setOpenModalReativar(false);

  useEffect(() => {
    const dados = {
      perfil: perfil,
      municipio: municipio,
      estabelecimentoDeSaude: estabelecimentoDeSaude,
      vinculoId: vinculoId,
      estado: null,
    };
    setDados(dados);
  }, []);

  async function handleDeleteVinculo(value) {
    if (value) {
      try {
        const { data } = await api.post("/inativar", {
          id: dados.vinculoId,
          status: status.CANCELADO,
        });

        setConfirmDelete(true);
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }
    }
    setModalDelete(false);
    setRefresh(!refresh);
  }

  async function handleReativarVinculo(value) {
    if (value) {
      try {
        const { data } = await api.post("/inativar", {
          id: dados.vinculoId,
          status: status.AGUARDANDO_HOMOLOGACAO,
        });
        setConfirmReativar(true);
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }
    }
    setOpenModalReativar(false);
    setRefresh(!refresh);
  }

  async function handleFavorito() {
    if (vinculoFavorito === true) {
      const response = await api
        .post("/favoritarVinculo", {
          co_id: vinculoId,
          st_favorito: false,
        })
        .then((res) => {
          console.log(res);
        });
      setVinculoFavorito(false);
    } else {
      const response = await api
        .post("/favoritarVinculo", {
          co_id: vinculoId,
          st_favorito: true,
        })
        .then((res) => {
          console.log(res);
        });
      setVinculoFavorito(true);
    }
    setRefresh(!refresh);
  }

  async function handleShowEdit() {
    try {
      const { data } = await api.post(`/vinculo/${dados.vinculoId}`);

      dados.perfil = data.perfil.id;
      dados.estado = data.uf.co_ibge;
      dados.municipio = data.municipio.co_ibge;
      dados.estabelecimentoDeSaude = data.estabelecimento.id;

      if (data.permiteEditar) {
        setOpenModalEditar(true);
      } else {
        alert("Só é possível editar um vínculo aguardando homologação");
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
    setRefresh(!refresh);
  }

  async function handleAccess() {
    try {
      const { data } = await api.post(`/vinculo/${dados.vinculoId}`);

      // localStorage.setItem("vinculo_ativo", JSON.stringify(data));
      setItemEncryp("vinculo_ativo", data);
      navigate("/home");
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  return (
    <>
      <Box component="div" sx={styles.border}>
        <Stack direction={"column"} sx={{ gap: "8px" }}>
          <Box>
            <Stack direction={"row"} justifyContent="space-between">
              <Box sx={styles.content}>
                <Box style={styles.profile}> {perfil}</Box>
              </Box>
              {statusVinculo === status.CANCELADO ? (
                <Box>
                  <IconButton
                    sx={{ color: yellow[800] }}
                    onClick={handleFavorito}
                  >
                    {vinculoFavorito ? (
                      <Tooltip title={"Desfavoritar"}>
                        <IconStarFill />
                      </Tooltip>
                    ) : (
                      <Tooltip title={"Favoritar"}>
                        <IconStar />
                      </Tooltip>
                    )}
                  </IconButton>
                </Box>
              ) : (
                <Box sx={styles.boxIcons}>
                  {statusVinculo == 0 && (
                    <Tooltip title={"Editar"}>
                      <IconButton style={{ color: "#1E729F" }}>
                        <IconEdit
                          onClick={() => {
                            handleShowEdit();
                          }}
                        />{" "}
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title={"Cancelar"}>
                    <IconButton
                      style={{ color: "#1E729F" }}
                      onClick={() => {
                        setModalDelete(true);
                      }}
                    >
                      <IconRemoveUser />
                    </IconButton>
                  </Tooltip>
                  <IconButton
                    sx={{ color: yellow[800] }}
                    onClick={handleFavorito}
                  >
                    {vinculoFavorito ? (
                      <Tooltip title={"Desfavoritar"}>
                        <IconStarFill />
                      </Tooltip>
                    ) : (
                      <Tooltip title={"Favoritar"}>
                        <IconStar />
                      </Tooltip>
                    )}
                  </IconButton>
                </Box>
              )}
            </Stack>
          </Box>
          <Divider sx={{ mt: 2, mb: 2 }} />
          <Box sx={styles.content}>
            <Box width="24px" height="24px">
              <IconLocation />
            </Box>
            <Box style={styles.label}> {municipio}</Box>
          </Box>
          <Box sx={styles.contentEstabelecimento}>
            <Box width="24px" height="24px">
              <IconHospital />
            </Box>

            <Box style={styles.label}> {estabelecimentoDeSaude} </Box>
          </Box>
        </Stack>
        <Divider sx={{ mt: 2, mb: 2 }} />
        <Box>
          <Stack
            direction={"column"}
            alignItems="flex-end"
            sx={{ width: "auto", marginTop: "16px" }}
            spacing={1}
          >
            <Box>
              {statusVinculo === status.CANCELADO ? (
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenModalReativar(true);
                  }}
                  style={{
                    color: "#1E729F",
                    borderWidth: 2,
                    borderColor: "#1E729F",
                  }}
                  endIcon={<ArrowForwardIosOutlined />}
                >
                  Reativar
                </Button>
              ) : statusVinculo === status.AGUARDANDO_HOMOLOGACAO ? (
                <Stack direction={"row"} spacing={1}>
                  <AccessTime />
                  <Box>{labelStatusVinculo[statusVinculo]}</Box>
                </Stack>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleAccess}
                  style={{ backgroundColor: "#1E729F" }}
                  endIcon={<ArrowForwardIosOutlined />}
                >
                  Acessar
                </Button>
              )}
            </Box>
          </Stack>
        </Box>
        <ModalDialogs
          open={modalDelete}
          onClose={() => handleDeleteVinculo(false)}
          title="Inativar Vínculo"
          body="Você realmente deseja inativar esse vínculo?"
          onActionPrimary={() => handleDeleteVinculo(true)}
          onActionSecondary={() => handleDeleteVinculo(false)}
          secondaryButtonText="Cancelar"
          primaryButtonText="Inativar Vínculo"
        />

        <ModalDialogs
          open={confirmDelete}
          onClose={() => setConfirmDelete(false)}
          title="Success"
          modalType="success"
          body={
            <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
              <Box>Vínculo inativado</Box>
              <Box fontSize="16px" fontWeight="400">
                Seu vínculo foi inativado com sucesso
              </Box>
            </Box>
          }
        />

        <ModalDialogs
          open={openModalReativar}
          onClose={() => handleReativarVinculo(false)}
          title="Reativar Vínculo"
          body={"Você realmente deseja reativar esse vínculo?"}
          onActionPrimary={() => handleReativarVinculo(true)}
          onActionSecondary={() => handleReativarVinculo(false)}
          secondaryButtonText="Cancelar"
          primaryButtonText="Reativar Vínculo"
        />

        <ModalDialogs
          open={confirmReativar}
          onClose={() => setConfirmReativar(false)}
          title="Sucesso"
          modalType="success"
          body={
            <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
              <Box>Vínculo reativado</Box>
              <Box fontSize="16px" fontWeight="400">
                Seu vínculo foi reativado com sucesso
              </Box>
            </Box>
          }
        />

        <AdicionarVinculos
          openModal={openModalEditar}
          setOpenModal={handleCloseEditar}
          edit={true}
          dados={dados}
          modalHeaderText="Editar vínculo"
          setRefresh={handleRefresh}
          refresh={refresh}
        ></AdicionarVinculos>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </>
  );
}
